export const backgroundColorConst = [0 ,0.4, 0.7, 1]
